module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"button":{"create":"Создать","edit":"Редактировать","confirm":"Подтвердить","delete":"Удалить"},"field":{"createdAt":"Создан","id":"Номер","name":"Название","description":"Описание","actions":"Действия","location":"Локация"},"modal":{"delete":{"message":"Вы уверены, что хотите удалить эту точку?","title":"Подтверждение","ok":"УДАЛИТЬ","cancel":"Отмена"}},"empty":"Пусто"}}')
  delete Component.options._Ctor
}
